import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Context } from 'components/PinToBoardModal';

import pinIcon from 'images/pin-to-board.svg';

const PinToBoardButton = (props) => {
  const {
    getChartInfo,
  } = props;

  const context = useContext(Context);

  const onClick = () => {
    const {
      CDF: data,
      Title: title,
      Subtitle: subtitle,
    } = getChartInfo();

    const pin = {
      type: 'data',
      data_type: 'Chart',
      data,
      title,
      subtitle,
    };

    context.fn(pin);
  };

  return (
    <StyledButton
      onClick={onClick}
      title="Add to Board"
    />
  );
};

PinToBoardButton.propTypes = {
  getChartInfo: PropTypes.func,
};

const StyledButton = styled.button`
  height: 60px;
  width: 60px;

  background-image: url(${pinIcon});
  background-size: 30px;
  background-position: center;

  position: relative;
  &:before, &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &:after {
    background-image: url(${pinIcon});
    background-size: 30px;
    background-position: center;
  }

  &:hover, &:focus-visible {
    &:before {
      background-color: ${(props) => props.theme.brandDark};
    }

    &:after {
      filter: invert(1);
    }
  }
`;

export default PinToBoardButton;



// WEBPACK FOOTER //
// ./app/components/Chart/PinToBoardButton.js